import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { InnField, InnFieldProps } from './InnField';

interface ControlledInnFieldProps<T extends FieldValues>
  extends Omit<InnFieldProps, 'name'> {
  name: Path<T>;
  control: Control<T>;
}

export const ControlledInnField = <T extends FieldValues>({
  name,
  control,
  variant = 'outlined',
  ...props
}: ControlledInnFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <InnField
          {...field}
          {...props}
          variant={variant}
          ref={field.ref}
          value={field.value}
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
};
